import React from "react";
import { useRole } from "../context/RoleContext";

// A warm coral gradient band that breaks up the dark page.
const Marquee = () => {
  const { marquee } = useRole();
  const items = [...marquee, ...marquee];

  return (
    <div
      data-testid="marquee-section"
      className="relative overflow-hidden border-y-4 border-[#2A2F45]"
      style={{
        background:
          "linear-gradient(90deg, #2A2F45 0%, #FF8A5B 30%, #FFD2A6 55%, #FFF3E9 78%, #FFD2A6 100%)"
      }}
    >
      <div
        className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to right, #2A2F45, rgba(42, 47, 69,0))"
        }}
      />
      <div
        className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to left, #FFD2A6, rgba(255, 210, 166,0))"
        }}
      />

      <div className="py-4 flex marquee-track">
        {items.map((item, i) => (
          <div
            key={`${item}-${i}`}
            className="shrink-0 px-5 flex items-center gap-3 whitespace-nowrap"
          >
            <span className="text-[#121826] text-[15px]">✦</span>
            <span className="display text-[15px] md:text-[17px] text-[#121826] tracking-tight">
              {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
